export const MAX_EXPORT_RECORDS = 10000;

export async function fetchAllPages({
  pageSize = 100,
  maxRecords = MAX_EXPORT_RECORDS,
  fetchPage,
}) {
  const entities = [];
  let pageNumber = 1;
  let pageCount = 1;
  let capped = false;

  do {
    const page = await fetchPage({ pageNumber, pageSize });
    const pageEntities = page?.entities || page?.results || [];

    entities.push(...pageEntities);
    pageCount = Number(page?.pageCount || page?.pageCount === 0 ? page.pageCount : pageCount) || 1;

    if (entities.length >= maxRecords) {
      capped = true;
      break;
    }

    pageNumber += 1;
  } while (pageNumber <= pageCount);

  return {
    entities: entities.slice(0, maxRecords),
    capped,
  };
}

export function unsupportedExport(message) {
  return async () => {
    throw new Error(message);
  };
}

export async function mapWithConcurrency(items, mapper, concurrency = 4) {
  const results = [];
  let nextIndex = 0;

  async function worker() {
    while (nextIndex < items.length) {
      const currentIndex = nextIndex;
      nextIndex += 1;
      results[currentIndex] = await mapper(items[currentIndex], currentIndex);
    }
  }

  const workerCount = Math.min(concurrency, items.length);
  await Promise.all(Array.from({ length: workerCount }, worker));

  return results;
}